import { CustomSWRConfig } from "infra";
import { SWRConfigContainerProps } from "typing";

const SWRConfigContainer = (props: SWRConfigContainerProps) => {
  return <CustomSWRConfig {...props} />;
};

export { SWRConfigContainer };
